import { FulfillmentHold } from "@redotech/redo-fulfillment-group-common/fulfillment-hold";
import { ShopifyFulfillmentHoldDisplayNames } from "@redotech/redo-fulfillment-group-common/shopify-fulfillment-schemas";

export function formatHold(hold: FulfillmentHold): string {
  const label = ShopifyFulfillmentHoldDisplayNames[hold.reason] ?? hold.reason;
  return hold.reasonNotes ? `${label}: ${hold.reasonNotes}` : label;
}

export function formatHoldNotes(
  holds: FulfillmentHold[] | null | undefined,
): string {
  if (!holds || holds.length === 0) {
    return "";
  }
  return holds.map(formatHold).join("\n");
}
